import { render, staticRenderFns } from "./InstallationsSideviewItemsTab.vue?vue&type=template&id=c6617318&scoped=true&class=fill-height&"
import script from "./InstallationsSideviewItemsTab.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideviewItemsTab.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideviewItemsTab.vue?vue&type=style&index=0&id=c6617318&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6617318",
  null
  
)

export default component.exports